//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#login

class UserLoginEventListener {
    // Language: javascript
    // Path: UserLoginEventListener.js
    // Compare this snippet from EventListener.js:
    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }
    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();

        var method = this.value;
        dataLayer
            .push({
                event: "login",
                method: method,
            })
            .then(() => {
                console.log("GTM pushed user_login event");
            })
            .catch((error) => {
                console.warn("GTM error user_login event", error);
            });

        if (typeof gtag !== "undefined" && !!gtag) {
            gtag("event", "login", {
                method: method,
            });
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            ProductSearchEventListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(
            this.eventName,
            ProductSearchEventListener.prototype.callback
        );
    }
}
